export default __webpack_public_path__ + "static/media/Silk-Serif-Bold.6dd2b01d.otf";